export const reportingQueryKeys = {
  all: ['reporting'] as const,
  aiSummaryStats: () => [...reportingQueryKeys.all, 'genesys-call-summary-stats'] as const,
  csDashboardStats: (featureIds: string[], startAt?: string, endAt?: string) =>
    [...reportingQueryKeys.all, 'cs-dashboard-stats', featureIds, startAt, endAt] as const,
};
